import { render, staticRenderFns } from "./TkHotelModal.vue?vue&type=template&id=33106816&"
import script from "./TkHotelModal.vue?vue&type=script&lang=js&"
export * from "./TkHotelModal.vue?vue&type=script&lang=js&"
import style0 from "./TkHotelModal.vue?vue&type=style&index=0&id=33106816&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports